import { Handle, Position } from '@xyflow/react';
import type { TipoAlvo } from '@nexital/shared';

/** Id da ponta de um item dentro do módulo (a seta chega no item, não no módulo inteiro). */
export const idPontaItem = (uuid: string) => `i:${uuid}`;

/**
 * Marca um item de módulo (documento, passo, marco, pessoa) como alvo de post-its e setas: atributos para achar
 * o item sob o ponteiro e pontas invisíveis para o React Flow desenhar a seta até ele.
 */
export function atributosAlvo(tipo: TipoAlvo, uuid: string) {
  return { 'data-alvo-tipo': tipo, 'data-alvo-uuid': uuid };
}

export function PontaItem({ uuid }: { uuid: string }) {
  const id = idPontaItem(uuid);
  return (
    <>
      <Handle type="target" id={id} position={Position.Left} className="ponta-oculta" isConnectable={false} />
      <Handle type="source" id={id} position={Position.Right} className="ponta-oculta" isConnectable={false} />
    </>
  );
}
